import { UIHeading1, UIHeading2, UIHeading4, UIHeading3 } from '../../../typography';
import { IconActionChevronDown16, IconActionChevronDown24 } from '@cian/ui-kit-design-tokens/icons';
export var ACCORDION_SIZE_PARAMS = {
  XS: {
    Title: UIHeading4,
    ArrowIcon: IconActionChevronDown16
  },
  S: {
    Title: UIHeading3,
    ArrowIcon: IconActionChevronDown16
  },
  M: {
    Title: UIHeading2,
    ArrowIcon: IconActionChevronDown24
  },
  L: {
    Title: UIHeading1,
    ArrowIcon: IconActionChevronDown24
  }
};